/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: getters.ts
 * Class: getters.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { GetterTree } from 'vuex';
import { ExtensionPrice, PriceResponse, PriceState } from './types';
import { MutationRequestStatus, RootState } from '../types';
import { getDefaultErrorState, getDefaultLoadingState } from '@a/store/utils';

export const getters: GetterTree<PriceState, RootState> = {
  /**
   * returns the actual RAW price API response
   * @param state
   */
  price(state): PriceResponse {
    return state.productPrice.data;
  },
  /**
   * returns true if the customer has a saved payment method
   * @param state
   */
  hasContract(state): boolean {
    return state.productPrice.status === MutationRequestStatus.SUCCESS
    && state.productPrice.data.price
      ? state.productPrice.data.price.payment.contract === true
      : false;
  },
  /**
   * returns the extension prices if the price API Response contains any
   * @param state
   */
  extensionPrices(state) : ExtensionPrice[] {
    return state.productPrice.status === MutationRequestStatus.SUCCESS
      ? state.productPrice.data.extensions
      : [];
  },

  isProductPriceLoading:
    (state) : boolean => state.productPrice.status === getDefaultLoadingState().status,

  isProductPriceFailure:
    (state) : boolean => state.productPrice.status === getDefaultErrorState().status,

  isProductPriceLoaded:
    (state) : boolean => state.productPrice.status === MutationRequestStatus.SUCCESS,
};
